/**
 * Cart Counter Updater - Global cart counter synchronization
 *
 * Listens to PUB_SUB_EVENTS.cartUpdate and updates cart counters
 * in header (desktop and mobile) across all pages.
 *
 * Works with any feature that publishes cartUpdate:
 * - Quick Add (overlay and mini modal)
 * - Product Form
 * - Cart Drawer
 * - Cart quantity changes
 */

class CartCounterUpdater {
  constructor() {
    this.init();
  }

  init() {
    // Subscribe to cart update events
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        console.log('[CartCounterUpdater] Received cartUpdate event from:', event.source);
        this.updateCounters();
      });
    } else {
      console.warn('[CartCounterUpdater] PubSub not available, counters will not auto-update');
    }
  }

  /**
   * Update cart counters by fetching current cart state and updating DOM directly
   */
  async updateCounters() {
    try {
      // Fetch cart JSON to get item count
      const cart = await ShopifyAPI.Cart.getJSON();
      const itemCount = cart.item_count;

      console.log('[CartCounterUpdater] Cart item count:', itemCount);

      // === UPDATE DESKTOP COUNTER ===
      const desktopCounter = document.getElementById('cart-icon-bubble');
      if (desktopCounter) {
        if (itemCount > 0) {
          desktopCounter.textContent = `(${itemCount})`;
          desktopCounter.classList.remove('hidden');
        } else {
          desktopCounter.textContent = '';
          desktopCounter.classList.add('hidden');
        }
        console.log('[CartCounterUpdater] ✅ Desktop counter updated');
      } else {
        console.warn('[CartCounterUpdater] ⚠️  Desktop counter not found');
      }

      // === UPDATE MOBILE COUNTER ===
      const mobileCounterLink = document.getElementById('cart-icon-bubble-mobile');
      if (mobileCounterLink) {
        // Find the counter span inside the link
        let mobileCounter = mobileCounterLink.querySelector('.header-mobile__cart-count-bubble span[aria-hidden="true"]');
        let bubbleDiv = mobileCounterLink.querySelector('.header-mobile__cart-count-bubble');

        if (itemCount > 0 && itemCount < 100) {
          if (mobileCounter) {
            // Update existing counter
            mobileCounter.textContent = itemCount;
          } else {
            // Create counter if it doesn't exist
            bubbleDiv = document.createElement('div');
            bubbleDiv.className = 'header-mobile__cart-count-bubble';
            bubbleDiv.innerHTML = `
              <span aria-hidden="true">${itemCount}</span>
              <span class="visually-hidden">${itemCount} itens</span>
            `;
            mobileCounterLink.appendChild(bubbleDiv);
          }
        } else if (itemCount === 0 && bubbleDiv) {
          // Remove bubble when cart is empty
          bubbleDiv.remove();
        }
        console.log('[CartCounterUpdater] ✅ Mobile counter updated');
      } else {
        console.warn('[CartCounterUpdater] ⚠️  Mobile counter not found');
      }

    } catch (error) {
      console.error('[CartCounterUpdater] ❌ Error updating counters:', error);
    }
  }
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartCounterUpdater();
  });
} else {
  new CartCounterUpdater();
}
